import { useEffect } from 'react';
import Layout from '../Layout/Layout';
import Table from '../../components/styled/Table';
import useAsync from '../../hooks/async';
import { getUrlFinderStatus } from '../../api/services/entities';

const UrlFinderStatus = () => {
  const query = useAsync();

  const { run, data } = query;
  const list = data?.searchEntityDtos || [];

  useEffect(() => {
    run(getUrlFinderStatus());
  }, [run]);

  const getHeaders = () => [
    'Code',
    'Entity Name',
    'Status',
    'Source',
    'Last Run Time (UTC)',
  ];

  const getRows = () =>
    list.map((item) => [
      item.code,
      item.searchTerm,
      item.status,
      item.searchEngine,
      item.lastRun,
    ]);

  return (
    <Layout title="URL Finder Status">
      <Table
        id="url-finder-status-table"
        headers={getHeaders()}
        rows={getRows()}
      />
    </Layout>
  );
};

export default UrlFinderStatus;
